/**
 * 彩票相关服务方法
 * 严禁使用全局变量！
 */

import { DRAW_WEB } from '../constants/config'
import { LOTTERY_METHOD_SWITCHER, ACTIVE_MISSING_FN_METHOD, DISABLE_MENUID_IDS,getMethodModes } from '../constants/lotterys/config'
import $CACHE from '../helpers/cache'
import * as UNIT from '../helpers/unit.js';




/**
 * 初始化投注数据
 * 该方法生成的初始化选号值与【makeSscSelectCodes】方法判断条件应该保持一一对应
 * 即使多种不同的选号方式为同一种初始化方法也应该分开判断！！！
 * @param  {[type]} currentMethod [description]
 * @param  {[type]} currentBet    [description]
 * @return {[type]}               [description]
 */
export function initBetData(currentMethod, currentBet,flag) {
  let bet = {};
  bet.methodid = currentMethod.methodid;
  // 玩法偏好对象
  let storeMethods = $CACHE.get('USER_METHOD_PREFERENCE_' + window.userId);
  storeMethods = storeMethods ? storeMethods.data : [];
  const methodPreference = _.find(storeMethods, {menuid: currentMethod.menuid});

  if (currentBet.mode) {
    const _currentMode = _.find(currentMethod.modes, {modeid: currentBet.mode.modeid});
    if (_currentMode) {
      bet.mode = currentBet.mode;
    }else{
      bet.mode = currentMethod.modes[0];
    }
    storeMethodsPreference(currentMethod.menuid, 'mode', bet.mode);
  }else{
    if (methodPreference && methodPreference.mode) {
      bet.mode = methodPreference.mode;
    }else{
      bet.mode = currentMethod.modes[0];
    }
  }
  // 如果已经投注过
  if (currentBet.prize) {
    bet.prize = currentBet.prize;
  }else{
    bet.prize = currentMethod.prize ? currentMethod.prize[currentMethod.prize.length - 1].value : null;
  }
  bet.times = currentBet.times || 1;
  bet.display = {
    num: 0,
    money: 0
  };
  if (currentMethod.selectarea.selPosition) {
    // 偏好还原
    if (methodPreference && methodPreference.poschoose) {
      bet.poschoose = methodPreference.poschoose;
    }else{
      bet.poschoose = _.chain(currentMethod.defaultposition).split('').map((item) => Number(item) ? true : false).value();
    }
  }
  bet.codes = [];
  // 数字型
  if (currentMethod.selectarea.type == 'digital' && currentMethod.selectarea.layout) {
    _.forEach(currentMethod.selectarea.layout, function (item, index) {
      bet.codes[index] = [];
    })
  }
  // 输入型，单式
  if (currentMethod.selectarea.type == 'input') {
    bet.codes = '';
  }
  // 大小单双
  if (currentMethod.selectarea.type == 'dxds' && currentMethod.selectarea.layout) {
    _.forEach(currentMethod.selectarea.layout, function (item, index) {
      bet.codes[index] = [];
    })
  }
  // 对决 PK
  if (currentMethod.selectarea.type == 'pk') {
    bet.codes = window.CLIENT_MODE == 'PC' ? [[], [], [], [], [], [], [], [], [], []] : [[], [], [], [], []];
  }
  // 普通和互斥骰子
  if (currentMethod.selectarea.type == 'dice' || currentMethod.selectarea.type == 'dice_relation') {
    _.forEach(currentMethod.selectarea.layout, function (item, index) {
      bet.codes[index] = [];
    })
  }
  // 全选骰子
  if (currentMethod.selectarea.type == 'dice_all') {
    bet.codes = '';
  }
  // 快乐8，盒子项
  if (currentMethod.selectarea.type == 'box') {
    bet.codes = [];
  }
  //返回
  return bet;
}


/**
 * 筛选投注栏中TAB菜单的常规玩法和特殊玩法
 * @param  {[type]} methods [当前静态玩法对象]
 * @return {[type]}         [返回添加标识的玩法对象]
 */
export function specialMethodFilter(methods) {
  if (!_.includes(LOTTERY_METHOD_SWITCHER, Number(methods.lotteryId))) {
    methods.needFilter = false;
    return methods;
  }

  _.forEach(methods.data_label, function (category, index) {
    // 常规玩法
    category.type = 'cg';
    // 特殊玩法
    if (_.includes(category.title, '任选') || index > 10) {
      category.type = 'ts';
    }

  })

  methods.needFilter = true;
  return methods;
}

 
/**
 * 设置当前选中的类别
 * @param {[type]} __methods    [redux总玩法对象]
 * @param {[type]} flag         [当前彩种]
 * @param {[type]} type         [玩法类型]
 * @param {[type]} categoryName [分类名称]
 * @return {[OBJECT]}           [返回对象categroy]
 */
export function setCurrentCategory(__methods, flag, type='cg', categoryName) {
  // var _dynamic = _.find(__methods.dynamic, {flag: flag})
  var _static = __methods.static[flag];
  var _currentCategory = null;
  // 默认选中
  if (!categoryName) {
    // 需要筛选
    if (_static.needFilter) {
      _currentCategory = _.find(_static.data_label, { type: type, isdefault: '1' })
      // 当前默认值不在当前选区，或没有默认值, 那么在当前选区取第一个值
      if (!_currentCategory) {
        _currentCategory = _.find(_static.data_label, { type: type })
      }
    } else {
      // 不需要筛选
      _currentCategory = _.find(_static.data_label, { isdefault: '1' })
      if (!_currentCategory) {
        _currentCategory = _static.data_label[0];
      }
    }
  } else {
    _currentCategory = _.find(_static.data_label, { title: categoryName })
    if(!_currentCategory){
      _currentCategory = _static.data_label[0];
      _currentCategory.close = true;
      let storeMethods = $CACHE.get('METHOD_MEMORY_' + window.userId);
      storeMethods = storeMethods ? storeMethods.data : [];
      let data = _.find(storeMethods, {alias: flag});
      if(data){
        $CACHE.remove('METHOD_MEMORY_' + window.userId);
        storeMethods = _.filter(storeMethods, (item) => item.alias != flag);
        $CACHE.put('METHOD_MEMORY_' + window.userId, storeMethods, 30)
      }
    }
  }

  // 用户没有权限
  if (!_currentCategory) {return null}
  var result = {};
  result.name = _currentCategory.title;
  result.flag = flag;
  result.categories = [];

  _.forEach(_currentCategory.label, function (item, index) {
    var cate = {
      title: item.gtitle,
      methods: []
    };
    _.forEach(item.label, function (it, idx) {
      // 临时屏蔽玩法
      if (_.includes(DISABLE_MENUID_IDS, it.menuid)) {return true};
      var meth = {
        id: it.methodid,
        name: it.name,
        desc: it.desc,
        menuid: it.menuid
      }
      cate.methods.push(meth);
    })
    result.categories.push(cate);
    if(_currentCategory.close){
      result.close = _currentCategory.close
    }
  })
  return result;

}

/**
 * 设置当前选中的玩法
 * @param {[type]} category     [玩法组]
 * @param {[type]} menuId       [菜单ID]
 */
export function setCurrentMethod(category, menuId) {
  var _static, _dynamic = null;
  // 默认选中
  if (!menuId) {
    menuId = category.categories[0].methods[0].menuid;
  }
  _dynamic = _.find(window.METHODS.dynamic, { menuid: menuId });

  // 无权限
  if (!_dynamic) { return null }
  // 有权限
  _static = _.find(window.METHODS.static[category.flag].data_label, { title: category.name });
  _static = _.chain(_.concat(..._.chain(_static.label).map('label').value())).find({ menuid: menuId }).value();

   // 根据彩种获取不同的投注
  const dyStaticData = function(){
    const cache = window.localStorage.getItem('static_lottery_' + category.flag);
    if (!cache){
      return [];
    }
    return JSON.parse(cache);
  }()
  _static.modes = _.chain(dyStaticData).get('data.labels').map('labels').flatten().map('labels').flatten().find({menuid:menuId}).get('money_modes').value() || getMethodModes();

  // 厘模式增加
  if (_static.modes.length === 3) {
    _static.modes.push({modeid: 4, name: "厘", rate: 0.001})
  }

  // 合并动态静态区
  const done = _.merge(
    _static,
    { 
      prize: _dynamic.prize_group,
      level: _dynamic.prize_level
    }
  );

  if (window.MODEL=='dev' || process.env.NODE_ENV == 'dev') {
      // console.group('#当前选中玩法(' + done.desc + ') #');
      // console.log('# name:' + done.name);
      // console.log('# menuid:' + done.menuid);
      // console.log('# methodid:' + done.methodid);
      // console.log(done);
      // console.groupEnd();
  }
  // 玩法记忆
  const methodMemory = {
    alias: category.flag,
    category: category.name,
    menuid: done.menuid,
    hash: window.location.hash
  }
  let storeMethods = $CACHE.get('METHOD_MEMORY_' + window.userId);
  storeMethods = storeMethods ? storeMethods.data : [];
  $CACHE.remove('METHOD_MEMORY_' + window.userId)
  storeMethods = _.filter(storeMethods, (item) => item.alias != methodMemory.alias);
  storeMethods.push(methodMemory);
  $CACHE.put('METHOD_MEMORY_' + window.userId, storeMethods, 30)
  return done;

}


/**
 * 记住用户选择的玩法偏好
 * @author ammo 2018-07-10
 * @param  {[type]} menuid [description]
 * @param  {[type]} key    [description]
 * @param  {[type]} value  [description]
 * @return {[type]}        [description]
 */
export function storeMethodsPreference(menuid, key, value){
    let storeMethods = $CACHE.get('USER_METHOD_PREFERENCE_' + window.userId);
    storeMethods = storeMethods ? storeMethods.data : [];
    $CACHE.remove('USER_METHOD_PREFERENCE_' + window.userId)
    
    // 取出已存的玩法偏好
    let methodPreference = _.find(storeMethods, {menuid: menuid}) || {};
    methodPreference.menuid = menuid;
    methodPreference[key] = value;

    // 重置当前的玩法偏好
    storeMethods = _.filter(storeMethods, (item) => item.menuid != menuid);
    storeMethods.push(methodPreference);
    $CACHE.put('USER_METHOD_PREFERENCE_' + window.userId, storeMethods, 30)
}

/**
 * 纠正大小写等格式输入错误
 * @param  {[type]} codes [输入值]
 * @return {[type]}       [纠正后的正确值]
 */
export function correctInputData(codes) {
  // 前后空格
  // codes = _.trim(codes);
  // 允许输入值
  codes = codes.replace(/[^\s\r,;，；　０１２３４５６７８９0-9]/g, "");
  // 大小写
  codes = codes.replace(/０/g, "0").replace(/１/g, "1").replace(/２/g, "2").replace(/３/g, "3").replace(/４/g, "4").replace(/５/g, "5").replace(/６/g, "6").replace(/７/g, "7").replace(/８/g, "8").replace(/９/g, "9");
  return codes;
}

/**
 * 生成投注时的提示语
 * @param  {[type]} bet [description]
 * @return {[html]}     [description]
 */
export function makeBetSubmitConfirmText(bet, needSolo) {
  const traceNum = _.size(bet.trace.lt_trace_issues);
  let title = '';
  if ( traceNum > 0) {
    title = '确定要追号' + traceNum + '期？';
  }
  if ( traceNum == 0 && bet.flag != 'mmc') {
    title = '确定要加入' + bet.current_issue.current.issue  + '期？';
  }
  // 秒秒彩单独TITLE
  if (bet.flag == 'mmc') {
    title = '确定要加入本次游戏？'; 
  }
  let content = '';
  const hasSolo = _.find(bet.display, {solo: true}, 'asc');
  if (hasSolo && needSolo) {
    content += '<p class="color-red solo">投注包含单挑注单，单挑注单盈利上限为3万元<p/>';
  }
  content += '<div class="floatarea" >';
  const orderDisplay = _.orderBy(bet.display, ['solo'], ['desc'])
  let modeName = ""
  _.forEach(orderDisplay, function (item) {
    if(item.mode=="元"){
      modeName = "yuan"
    }
    if(item.mode=="角"){
      modeName = "jiao"
    }
    if(item.mode=="分"){
      modeName = "fen"
    }
    if(item.mode=="厘"){
      modeName = "li"
    }
    if (item.solo && needSolo) {
      content += '<p class="ellipsis color-red"><i>单挑</i><span class="'+ modeName +'">' + item.mode + '</span><b>' + item.methodName + '　<span class="pormpt">' + _.round(item.money, 3).toFixed(3) +'元</span><br/><span class="color-graypurple">号码：</span><span class="codes">'+ item.codes + '</span></b></p>';
    }else{
      content += '<p class="ellipsis"><span class="'+ modeName +'">' + item.mode + '</span><b>' + item.methodName + '　<span class="pormpt">'+ _.round(item.money, 3).toFixed(3) +'元</span><br/><span class="color-graypurple">号码：</span><span class="codes">' + item.codes + '</span></b></p>';
    }
  })
  content += '</div>';
  let total
  if(bet.flag != 'mmc'){
    total = '<div class="totleNum">' +
      '   <span class="numlabel">总金额:</span> ' +
      '   <span>' + (bet.trace.lt_trace_money || _.round(_.sum(_.map(bet.display, 'money')), 3).toFixed(3)) + ' 元</span> ' +
      '</div>';
  }else{
    total = '<div class="totleNum">' +
      '   <span class="numlabel">总金额:</span> ' +
      '   <span>' + (bet.trace.lt_trace_money || (_.round(_.sum(_.map(bet.display, 'money')), 3)*bet.times).toFixed(3)) + ' 元</span> ' +
      '</div>';
  }  
  return '<div class="title">' + title + '</div>' + content + total
}

/**
 * 生成秒秒彩ALERT的文字
 * @param  {[type]} bet   [description]
 * @param  {[type]} times [description]
 * @return {[type]}       [description]
 */
export function makeMmcBetSubmitAlertText(bet, times){
  const totalBouns = _.sum(_.map(bet.excute, 'bonus'));
  // 如果只投注了一次
  if (bet.times == 1) {
    if (totalBouns > 0) {
      UNIT.goToTop()
      return '<h3>恭喜您中奖啦</h3><h3>'+_.round(totalBouns, 4)+'元</h3>'
    }
    return '<h3>投注成功</h3>';
  }
  // 完成游戏
  if (bet.excute.length == bet.times) {
    // 合计中奖
    if (totalBouns > 0) {
      UNIT.goToTop()
      return '<h3>共中奖'+_.round(totalBouns, 4)+'元</h3>' +
             '<h4>共游戏'+bet.times+'次</h4>';
    }
    return '<h3>共游戏'+bet.times+'次</h3>';
  }
  // 没有完成游戏
  const win = _.chain(bet.excute).filter((item) => item.bonus > 0).last().value();
  // 显示上一次中奖情况
  if (win) {
    // 中奖停止游戏
    UNIT.goToTop()
    const _nowTimes = bet.stopWhenWin ? bet.excute.length : times;
    return '<h3>第'+_nowTimes+'次，共'+bet.times+'次</h3>' +
           '<h4>【第'+win.times+'次中奖'+_.round(win.bonus, 4)+'元】<br>共中奖'+_.round(totalBouns, 4)+'元</h4>'
  }
  return '<h3>第'+times+'次，共'+bet.times+'次</h3>'
}


/**
 * 生成秒秒彩ALERT按钮的文字
 * @param  {[type]} bet   [description]
 * @param  {[type]} times [description]
 * @return {[type]}       [description]
 */
export function makeMmcBetSubmitAlertButtonText(bet, times){
  const totalBouns = _.sum(_.map(bet.excute, 'bonus'));
  // 投注次数完成
  if (bet.excute.length == bet.times) {
    return '确定'
  }
  // 次数未完成
  // 中奖停止
  if (totalBouns > 0 && bet.stopWhenWin) {
    return '中奖了游戏停止';
  }
  // 停止
  return '停止';
}

/**
 * 通过历史奖期构造30,50,100每个号码都出了多少次
 * @param  {[type]} history [description]
 * @param  {[type]} periods [description]
 * @return {[type]}         [description]
 */
export function makeHistoryCodeNumbers(history, vaildCods){
  // 不同期的快照
  let snapshot_30 = {}, snapshot_50 = {}, snapshot_100 = {};
  let counter = _.map(vaildCods, function(item){ return {code: item, count: 0} });
  // 查询需要创建几维数组
  counter = _.map(history[0].split_code, () => _.cloneDeep(counter));
  // 循环
  _.forEach(history, function(item, index){
    _.forEach(item.split_code, function(code, idx){
      if(_.find(counter[idx], {code: code})){
        _.find(counter[idx], {code: code}).count ++
      }
    })
    // 30 期快照
    if (index + 1 === 30) {
      snapshot_30 = makeSnapshotData(counter)
    }
    // 50期快照
    if (index + 1 === 50) {
      snapshot_50 = makeSnapshotData(counter)
    }
    // 100期快照
    if (index + 1 === 100) {
      snapshot_100 = makeSnapshotData(counter)
    }
  })

  // 遗漏
  let formatMissCodes = [];
  _.forEach(_.map(history, 'split_code'), function(split_code){
    _.forEach(split_code, function(code, idx){
      formatMissCodes[idx] = formatMissCodes[idx] || [];
      formatMissCodes[idx].push(code);
    })
  })

  let missCodeCurrent = {}, missCodeMax = {};

  // 当前遗漏
  missCodeCurrent = _.map(formatMissCodes, function(missCodes){
    return makeMissCodeData(vaildCods, missCodes)
  })

  // 最大遗漏
  missCodeMax = _.map(formatMissCodes, function(missCodes){
    return makeMissCodeData(vaildCods, missCodes, true)
  })

  // 封装快照数据
  const result =  {
    _30:snapshot_30,
    _50:snapshot_50,
    _100:snapshot_100,
    miss_current: missCodeCurrent,
    miss_max: missCodeMax
  }
  return result;
}


/**
 * 封装快照数据
 * @param  {[type]} list [description]
 * @return {[type]}      [description]
 */
export function makeSnapshotData(list){
  
  let result = {
    minList: [],
    maxList: [],
    comList: [],
    list: []
  };

  _.forEach(list, function(snap, index){
    const _snap_ = _.cloneDeep(snap)
    const min = _.minBy(_snap_, 'count').count;
    const max =  _.maxBy(_snap_, 'count').count;
    result.minList[index] = _.filter(_snap_, (item) => item.count == min);
    result.maxList[index] = _.filter(_snap_, (item) => item.count == max);
    result.comList[index] = _.differenceBy(_snap_, _.concat(result.minList[index], result.maxList[index]), 'code');
    result.list[index] = _.map(result.minList[index], function(item){return _.merge(item, {status: 2})});
    result.list[index] = _.concat(result.list[index], ..._.map(result.maxList[index], function(item){return _.merge(item, {status: 1})}))
    result.list[index] = _.concat(result.list[index], ..._.map(result.comList[index], function(item){return _.merge(item, {status: 0})}))
    result.list[index] = _.orderBy(result.list[index], 'code')
  })

  return result.list;
}

/**
 * 封装当前遗漏号码
 * @param  {[type]} vaildCods [description]
 * @param  {[type]} codeList  [description]
 * @param  {[type]} isMax     [是否求最大]
 * @return {[type]}           [description]
 */
export function makeMissCodeData(vaildCods, codeList, isMax = false){
  let result = [];
  _.forEach(vaildCods, function(code, index){
    const miss = {
      code: code,
      count: isMax ? makeMaxMissCodeData(code, codeList) : _.indexOf(codeList, code) == -1 ? 100 : _.indexOf(codeList, code),
      status: 0,
    }
    result.push(miss);
  })
  // 筛选最大
  const max =  _.maxBy(result, 'count').count;
  result = _.map(result, function(item){
    if (item.count === max) {
      item.status = 1;
      return item;
    }
    return item;
  });

  return result;
}


/**
 * 计算最大遗漏数量
 * @param  {[type]} code     [description]
 * @param  {[type]} codeList [description]
 * @return {[type]}          [description]
 */
export function makeMaxMissCodeData(code, codeList, maxCount = -1){
  const count = _.indexOf(codeList, code) == -1 ? codeList.length : _.indexOf(codeList, code); 
  if (count == codeList.length) {
    return count > maxCount ? count : maxCount
  }
  // 递归
  return makeMaxMissCodeData(code, _.slice(codeList, count == 0 ? 1 : count, codeList.length), count > maxCount ? count : maxCount)
}


/**
 * 格式化推送数据
 * @param  {[type]} liveData [description]
 * @return {[type]}          [description]
 */
export function formatHistoryLiveData(liveData){
  let pushSaleInfo = [];
  _.forEach(liveData, function (value, key) {
    let lotterySale = _.merge(value, { lotteryId: _.split(key, '_')[1] });
    // 瑞典二分彩开奖号码特殊处理
    if (lotterySale.lotteryId == 27) {
      lotterySale.detail_code = _.chain(lotterySale.last_code).split(' ').chunk(4).value();
      lotterySale.last_code = _.chain(lotterySale.last_code).split(' ').map((item) => parseInt(item)).chunk(4).map((item) => _.sum(item) % 10).join('').value();
    }
    pushSaleInfo.push(lotterySale);
  })
  
  return pushSaleInfo;
}


/**
 * 当用户没有玩法权限时，在静态数据层直接屏蔽，预防显示
 * @return {[type]} [description]
 */
export function disableMethodsByDynamic(){
  // 还没有加载完成
  if (!window.METHODS.dynamic || !window.METHODS.static) {return;}
  // 如果从无到有，则需要从缓存中获取静态数据因此将METHODS.static 重新从缓存中赋值
  window.METHODS.static = $CACHE.get('method_static').data;
  window.METHODS.dynamic = $CACHE.get('method_dynamic').data.data;
  // 添加常规玩法和任选玩法标识
  _.forEach(window.METHODS.static, function(method, key){
    method = specialMethodFilter(method);
  })
  // 遍历静态区，从动态区进行过滤（逆向删除，先从最小玩法过滤，然后通过.length过滤子分类和大分类）
  _.each(window.METHODS.static, function(lottery, alias){
    _.each(lottery.data_label, function(mainCategory, index){
      _.each(mainCategory.label, function(subCategory, idx){
        _.each(subCategory.label, function(method, i){
          // 玩法删除
          if (!_.find(window.METHODS.dynamic, {menuid: method.menuid})) {
            delete subCategory.label[i]
          }
        })
        // 空玩法过滤
        subCategory.label = _.filter(subCategory.label, (method) => method);
        // 子分类删除
        if (subCategory.label.length == 0) {
          delete mainCategory.label[idx];
        }
      })
      // 空子玩法过滤
      mainCategory.label = _.filter(mainCategory.label, (sub_cate) => sub_cate);
      // 父分类删除
      if (mainCategory.label.length == 0) {
        delete lottery.data_label[index]
      }
    })
    // 空父玩法过滤
    lottery.data_label = _.filter(lottery.data_label, (cate) => cate);
  })
}
